var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L13.748 7.49221C13.9613 8.28444 14.068 8.68055 14.2785 9.00439C14.4647 9.29093 14.7091 9.53522 14.9957 9.72153C15.3194 9.932 15.7156 10.0387 16.5078 10.252L23 12L16.5078 13.748C15.7156 13.9613 15.3194 14.068 14.9957 14.2785C14.7091 14.4647 14.4647 14.7091 14.2785 14.9957C14.068 15.3194 13.9613 15.7156 13.748 16.5078L12 23L10.252 16.5078C10.0387 15.7156 9.932 15.3194 9.72153 14.9957C9.53522 14.7091 9.29093 14.4647 9.00439 14.2785C8.68055 14.068 8.28444 13.9613 7.49221 13.748L1 12L7.49221 10.252C8.28444 10.0387 8.68055 9.932 9.00439 9.72153C9.29093 9.53522 9.53522 9.29093 9.72153 9.00439C9.932 8.68055 10.0387 8.28444 10.252 7.49221L12 1Z",
    fill: "#16C098",
    stroke: "#16C098",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/greenStar.4803141d70e974cfbed381bb54791ffc.svg";
export { ForwardRef as ReactComponent };